import httpClient from './httpClient'
const messageAfterLogin = {
  getAllMessage (params) {
    return httpClient.get('/api/popup-messages', {params});
  }
}

export default messageAfterLogin
